import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "about" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Impressum"),
  /*#__PURE__*/_createElementVNode("h3", null, " Verantwortlich für den Inhalt: "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Tim Vogt"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Dreeblöcken 68"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 23570 Lübeck ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" E-Mail: "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:info@nightbane.de" }, "info@nightbane.de")
  ])
], -1)

import TextPageLayout from '@/components/text-page-layout.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ImpressumView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextPageLayout, null, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})